module.exports = __webpack_public_path__ + "static/media/icon-nav.bef5b777.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-nav.svg
// module id = 887
// module chunks = 0